export default __webpack_public_path__ + "static/media/assist_web-md@2x.ad1a5026.jpg";